// Mirai functions
window.mirai = window.mirai || {};

mirai.init = function () {
  mirai.oneTrustToggleInfoDisplayAnchors();
  mirai.mainNavInit();
  mirai.searchModal();
  mirai.languageModal();
  mirai.promotion();
};

mirai.oneTrustToggleInfoDisplayAnchors = function () {
  $(document).on('click', 'a[href=#cookie-settings]', function (event) {
    event.preventDefault();
    if (typeof window.OneTrust !== 'undefined') {
      window.OneTrust.ToggleInfoDisplay();
    }
  });
}

mirai.mainNavInit = function () {
  $('.nav-bar').stickThis({
    zindex: 7
  }).addClass('is-moved-by-drawer'); // Fixes nav-bar drawer transitions

  var activateSubmenu = function (row) {
    var $row = $(row);
    $row.addClass('menu-aimed-at');
    // $row.find('.site-nav__sub').css({
    //   display: 'block'
    // });
  };

  var deactivateSubmenu = function (row) {
    var $row = $(row);
    $row.removeClass('menu-aimed-at');
    // $row.find('.site-nav__sub').css({
    //   display: 'none'
    // });
  };

  $('.site-nav__main').menuAim({
    submenuDirection: 'below',
    tolerance: 25,
    activate: activateSubmenu,
    deactivate: deactivateSubmenu,
    exitMenu: function () {
      return true;
    }
  })
};

mirai.searchModal = function () {
  $('.open-search').fancybox({
    wrapCSS: 'search__modal-wrapper',
    margin: 0,
    padding: 0,
    keys: {
      close: [27] // escape key
    },
    afterShow: function () {
      $('#SearchContainer').find('input').first().focus();
    }
  });
};

mirai.languageModal = function () {
  $('.open-language').fancybox({
    wrapCSS: 'localize__modal-wrapper',
    margin: 0,
    padding: 0,
    keys: {
      close: [27] // escape key
    },
    afterShow: function () {
      $('#LanguageContainer').find('a, button').click(function () {
        $.fancybox.close();
      })
    }
  });
};

// Shim for smart doll variant selections
mirai.smartDollSelectors = function (name, options) {
  var changeButton = $('#ChangeVariant');
  var variantSelect = $('.variant-selector');
  var variantBuy = $('.product-single__variant-buy');

  var selectedClass = 'selected';
  var selector = 'input[type=radio][name=' + name + ']';
  var elements = $(selector);

  var product = new Shopify.Product(options.product);

  var onVariantSelected = Shopify.isDefined(options.onVariantSelected) ? options.onVariantSelected : function () {
  };
  var onVariantChange = Shopify.isDefined(options.onVariantChange) ? options.onVariantChange : function () {
  };

  $(document).on('change', selector, function (e) {
    var selected = $(this);
    var variant = product.getVariantById(selected.val());

    elements.parent().removeClass(selectedClass);
    selected.parent().addClass(selectedClass);
    onVariantSelected(variant, selected);

    variantSelect.fadeOut(function () {
      variantBuy.fadeIn();
    });
  });

  changeButton.click(function () {
    elements.removeAttr('checked');
    onVariantChange();

    variantBuy.fadeOut(function () {
      variantSelect.fadeIn();
    });
  })
};

mirai.productPage = function (product) {
  product.tag_list = product.tags.join(' ');
  // Coming soon property
  product.coming_soon = product.tag_list.indexOf('coming-soon') > -1;
  // In store only property
  product.in_store_only = product.tag_list.indexOf('in-store-only') > -1;
  // Localize options
  product.options = $.map(product.options, function (option) {
    return localize.buildString(option);
  });

  var productSlider = $('#ProductSlider'),
      productThumbs = $('#ProductThumbs'),
      productCarousel = $('#ProductCarousel'),
      productThumbsWrapper = $('.product-single__thumbnails-wrapper');

  var productThumbsViewMore = productThumbs.find('.view-more a').click(function (e) {
    e.preventDefault();
    productThumbsWrapper.addClass('product-single__thumbnails--expanded');
    $(this).hide('fast').parent().remove();
  });

  // Desktop product thumbs
  productThumbs.find('.product-single__thumbnail').fancybox({
    wrapCSS: 'product__image-wrapper',
    padding: 30,
    margin: 50, // Matches margin set in theme style
    nextEffect: 'fade',
    prevEffect: 'fade',
    minWidth: '60%',
    beforeShow: function () {
      var alt = this.element.find('img').prop('alt');
      if (alt && alt != product.title) {
        this.title = localize.buildString(alt);
      }
    }
  });

  // Mobile product slider
  // The slider being synced must be initialized first
  productCarousel.flexslider({
    animation: "slide",
    controlNav: false,
    animationLoop: false,
    slideshow: false,
    itemWidth: 100,
    itemMargin: 5,
    asNavFor: '#ProductSlider'
  });

  productSlider.flexslider({
    animation: "slide",
    controlNav: false,
    animationLoop: false,
    slideshow: false,
    smoothHeight: false,
    sync: "#ProductCarousel"
  });

  mirai.productEditor(product.id);
};

// Product addons UI
// Currenty only works with single variant/no variant products
mirai.productAddon = function (options) {
  var selectedProducts = [];
  var unavailableProducts = [];
  var productLookup = {};
  var collectionLookup = {};

  var $body = $('body');
  var $addon = $('#ProductAddon');
  var $addonTemplate = $("#ProductAddonTemplate");

  var init = function () {
    // Add item from a collection
    $body.on('click', '.product__addon-add a', function (e) {
      e.preventDefault();

      var $link = $(this);
      var collectionHandle = $link.data('collection');
      showModal(collectionHandle);
    });

    // Add selected item
    $body.on('click', '.product__addon-modal a', function (e) {
      e.preventDefault();

      var $gridItem = $(this).parents('.product-grid');
      var productId = $gridItem.data('product');
      var product = productLookup[productId];

      if (product) {
        selectedProducts.push(product);
        refreshData();
      }

      $.fancybox.close();
      refreshList();
    });

    // Remove selected item
    $body.on('click', '.product__addon-remove', function (e) {
      e.preventDefault();

      var $button = $(this);
      var $productAddon = $button.parents('.product__addon');
      var productId = $button.data('product');
      var product = productLookup[productId];
      var index = $.inArray(product, selectedProducts);

      if (index > -1) {
        selectedProducts.splice(index, 1);
        refreshData();
      }

      $productAddon.addClass('is-removed');

      // Slight delay to make sure removed animation is done
      setTimeout(function () {
        refreshList();
      }, 600);
    });

    // Init
    $.each(options.collections, function (i, collection) {
      // Localize/parse add from collection label
      collection.description = localize.buildString(collection.description);
      // Add collection to lookup
      collectionLookup[collection.handle] = collection;

      $.each(collection.products, function (i, product) {
        // Supplement default product info
        product.variant_id = product.variants[0].id;
        if (product.featured_image) {
          product.thumb_image = product.featured_image.replace(/(\.[^.]*)$/, "_grande_cropped$1");
        }
        else {
          product.thumb_image = "//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_medium_cropped.gif";
        }
        product.price_formatted = Shopify.formatMoney(product.price, options.moneyFormat);
        product.collection_handle = collection.handle;
        // Add product to lookup
        productLookup[product.id] = product;
        // Track unavailable products
        if (!product.available) {
          unavailableProducts.push(product);
        }
      });
    });

    refreshData();
    refreshList();
  };

  var findProductGridItem = function (product) {
    var $collectionTemplate = $('#collection-' + product.collection_handle);
    return $collectionTemplate.find('.product-grid[data-product=' + product.id + ']');
  };

  var refreshData = function () {
    var counts = {};
    $.each(selectedProducts, function (i, product) {
      counts[product.collection_handle] = (counts[product.collection_handle] || 0) + 1;
    });

    $.each(options.collections, function (i, collection) {
      var count = counts[collection.handle] || 0;
      collection.all_selected = count >= collection.products.length;
    });
  };

  var refreshList = function () {
    $addon.empty().append(buildList());
  };

  var buildList = function () {
    var source = $addonTemplate.html(),
        template = Handlebars.compile(source);

    var data = {
      selected_products: selectedProducts,
      collections: options.collections
    };

    return template(data);
  };

  var buildModal = function (collectionHandle) {
    var $collectionTemplate = $('#collection-' + collectionHandle);
    var $markup = $collectionTemplate.clone();

    // Remove unavailable and selected products
    var removeThese = unavailableProducts.concat(selectedProducts);

    // Remove selected products
    $.each(removeThese, function (i, product) {
      if (product.collection_handle == collectionHandle) {
        $markup.find('.product-grid[data-product=' + product.id + ']').remove();
      }
    });

    // Append select text to each remaing grid item
    var $selectElement = $('<div class="wrapper"><span class="boxed">' + localize.buildString('Select') + '</span></div>');
    $markup.find('.product-grid .grid__image').append($selectElement);

    return $markup;
  };

  var modalMargin = function () {
    return $(window).width() > 960 ? 120 : 20;
  };

  // Show modal
  var showModal = function (collectionHandle) {
    $.fancybox(buildModal(collectionHandle), {
      wrapCSS: 'product__addon-modal',
      margin: modalMargin(), // Matches margin set in theme style
      minWidth: '50%',
      maxWidth: 960,
      padding: 0,
      onUpdate: function () {
        $.fancybox.current.margin = modalMargin();
      }
    });
  };

  init();
};

// "Password protect" adding a product to cart
mirai.productLock = function (options) {
  var isLocked = true;
  var $formContainer = $(options.formSelector);
  var $addToCart = $(options.addToCartSelector);
  var $body;

  var init = function () {
    // General Selectors
    $body = $('body');

    // Override form behavior
    formOverride();

    // Update currency based on input on change
    $body.on('submit', '.product__lock-form', function (evt) {
      evt.preventDefault();

      var $lockForm = $(this);
      var userInput = $lockForm.find('input[name=key]').val();
      if (md5(userInput) === options.key) {
        isLocked = false;
        $formContainer.submit();
      }
      else {
        $formContainer.after('<div class="errors qty-error">' + localize.buildString("Invalid password!|パスワード間違っているぞ！") + '</div>');
      }

      $.fancybox.close();
    });
  };

  var formOverride = function () {
    $formContainer.on('submit', function (evt) {
      // Stop form submit and present unlock screen
      if (isLocked) {
        evt.preventDefault();
        evt.stopImmediatePropagation();

        // Add class to be styled if desired
        $addToCart.removeClass('is-added').addClass('is-adding');

        // Remove any previous quantity errors
        $('.qty-error').remove();

        showModal();
      }

      // Else allow event to pass through
    });
  };

  var buildModal = function () {
    var build = [];
    build.push('<form class="product__lock-form text-center form-vertical" role="confirm">');
    build.push('<h3>' + localize.buildString("What&#39;s the password?|パスワードを入力してください") + '</h3>');
    build.push('<img src="//en.megahobby.jp/cdn/shop/t/15/assets/lock.png?v=7430" />');
    build.push('<label for="key">' + localize.buildString("Please enter the password that customer service gave you|顧客サポートに教えてもらったパスワードを入力してください") + '</label>');
    build.push('<input type="password" name="key" placeholder="Password" class="input-full" />');
    build.push('<button type="submit" class="btn btn--full">' + localize.buildString("Add to Cart|カートに入れる") + '</button>');
    build.push('</form>');

    return build.join('');
  };

  var showModal = function () {
    $.fancybox($(buildModal()), {
      wrapCSS: 'product__lock-wrapper',
      margin: 0,
      padding: 0
    });
  };

  init();
};

// Time sale countdown
mirai.productTimeSale = function (options) {
  var $timeSaleContainers = $(options.containerSelector);
  var countdownFormats = options.countdownFormats;
  var saleEnded = localize.buildString(options.saleEnded);
  var timeSaleCountdowns = [];
  var formatParts = function (parts) {
    for (var key in parts) {
      parts[key] = ('00' + parts[key]).slice(-2);
    }
    return parts;
  };

  // Setup countdown templates
  for (var key in countdownFormats) {
    countdownFormats[key] = Handlebars.compile(localize.buildString(countdownFormats[key]));
  }

  // Setup countown function to call for each element
  $timeSaleContainers.each(function (index, el) {
    var $el = $(el);
    var cutoff = parseInt($el.data('time-sale'));
    var now = Math.floor((new Date).getTime() / 1000);
    var diff = cutoff - now - 1; // Diff in seconds minus 1 sec buff

    timeSaleCountdowns.push(function () {
      diff -= 1;

      if (diff < 1) {
        $el.html(saleEnded);
      }
      else {
        var parts = {
          days: Math.floor(diff / 86400),
          hours: Math.floor(diff / 3600) % 24,
          minutes: Math.floor(diff / 60) % 60,
          seconds: diff % 60
        };

        if (parts.days > 0) {
          $el.html(countdownFormats.days(formatParts(parts)));
        }
        else if (parts.hours > 0) {
          $el.html(countdownFormats.hours(formatParts(parts)));
        }
        else if (parts.minutes > 0) {
          $el.html(countdownFormats.minutes(formatParts(parts)));
        }
        else {
          $el.html(countdownFormats.seconds(formatParts(parts)));
        }
      }
    });
  });

  // Call every second
  var interval = setInterval(function () {
    for (var i = 0; i < timeSaleCountdowns.length; i++) {
      (timeSaleCountdowns[i])();
    }
  }, 1000);

  $(window).unload(function () {
    clearInterval(interval);
  });
};

mirai.itemEditor = function (itemType, itemId) {
  $(window).load(function () {
    if (window.location.protocol == 'https:') {
      var adminBar = $('#admin_bar_iframe');
      if (adminBar.length >= 1) {
        var editor = $('<a target="_blank" class="btn--secondary btn--small admin__item-editor" href="/admin/' + itemType + 's/' + itemId + '">Edit ' + itemType + '</a>')
        $('body').append(editor);
      }
    }
  });
};

mirai.productEditor = function (productId) {
  mirai.itemEditor('product', productId);
};

mirai.collectionEditor = function (collectionId) {
  mirai.itemEditor('collection', collectionId);
};

mirai.pageEditor = function (pageId) {
  mirai.itemEditor('page', pageId);
};

mirai.promotionReadKey = 'promotion.read.d41d8cd98f00b204e9800998ecf8427e';
mirai.promotionReadOnce = false;

mirai.promotion = function () {
  if (mirai.promotionReadOnce) {
    // Check for cookie key
    if (Cookies.get(mirai.promotionReadKey)) {
      $('#Promotion').hide();
    }
    else {
      $('#Promotion').find('a').click(function (e) {
        e.preventDefault();
        // Commented as of 2022-09-14
        // Cookies.set(mirai.promotionReadKey, true);
        window.location.href = $(this).prop('href');
      });
    }
  }
};

mirai.injectJapaneseFonts = function () {
  if (!mirai._fontsInjected) {
    var lightFont = new FontFaceObserver('Noto Sans Japanese', {weight: 300});
    var normalFont = new FontFaceObserver('Noto Sans Japanese', {weight: 400});
    var boldFont = new FontFaceObserver('Noto Sans Japanese', {weight: 700});

    Promise.all(
        [
          lightFont.load('日本語', 5000),
          normalFont.load('日本語', 5000),
          boldFont.load('日本語', 5000)
        ]
    ).then(function () {
      $('html').addClass('fonts-loaded');
    });

    $('<link/>', {
      rel: 'stylesheet',
      type: 'text/css',
      href: '//en.megahobby.jp/cdn/shop/t/15/assets/japanese_fonts.scss?v=154986977798707429741783473738'
    }).appendTo('head');

    mirai._fontsInjected = true;
  }
};

// Initialize immediately
mirai.init();
